import React from "react";
import { Outlet } from "react-router-dom";
import logo from '../logo1.jpg';
import FooterComponent from '../components/shared/FooterComponent';

const QrLayout = () => {
    
    return (
        <Outlet />
    )
}

export default QrLayout;